import { Box, Button, Typography } from "@mui/material";
import { TOTAL_STEPS } from "../types";
import { gradientBrand, passtrackColors } from "../theme";

interface WizardFooterProps {
  step: number;
  footerNote: string;
  nextDisabled: boolean;
  nextLabel?: string;
  onBack: () => void;
  onNext: () => void;
  editMode?: boolean;
  editPropertyName?: string;
  editDocumentId?: string;
}

export default function WizardFooter({
  step,
  footerNote,
  nextDisabled,
  nextLabel,
  onBack,
  onNext,
  editMode = false,
  editPropertyName = "",
  editDocumentId = "",
}: WizardFooterProps) {
  const isLastStep = step === TOTAL_STEPS;

  if (editMode) {
    return (
      <Box
        component="footer"
        sx={{
          position: "sticky",
          bottom: 0,
          zIndex: 1200,
          background: "rgba(255,255,255,.96)",
          backdropFilter: "blur(6px)",
          borderTop: `1px solid ${passtrackColors.borderSubtle}`,
          px: { xs: 2.5, md: 5 },
          py: 2,
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Box sx={{ minWidth: 0, display: "flex", flexDirection: "column", gap: 0.25 }}>
          <Typography
            sx={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: passtrackColors.blue900,
            }}
          >
            Modo edición
          </Typography>
          <Typography
            noWrap
            sx={{ fontSize: 14, fontWeight: 600, color: passtrackColors.ink }}
          >
            {editPropertyName || "Propiedad sin nombre"}
          </Typography>
          {editDocumentId ? (
            <Typography
              sx={{
                fontSize: 12,
                color: passtrackColors.textMuted,
                fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
              }}
            >
              {editDocumentId}
            </Typography>
          ) : null}
        </Box>
        <Button
          variant="contained"
          onClick={onNext}
          disabled={nextDisabled}
          sx={{
            backgroundImage: gradientBrand,
            "&:hover": {
              backgroundImage: gradientBrand,
              filter: "brightness(0.95)",
            },
          }}
        >
          {nextLabel ?? "Guardar cambios"}
        </Button>
      </Box>
    );
  }

  return (
    <Box
      component="footer"
      sx={{
        position: "sticky",
        bottom: 0,
        zIndex: 1200,
        background: "rgba(255,255,255,.96)",
        backdropFilter: "blur(6px)",
        borderTop: `1px solid ${passtrackColors.borderSubtle}`,
        px: { xs: 2.5, md: 5 },
        py: 2,
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Button variant="text" onClick={onBack} disabled={step === 1}>
        Atrás
      </Button>
      <Typography
        sx={{
          fontSize: 13,
          color: passtrackColors.textMuted,
          flex: "1 0 auto",
          textAlign: "center",
        }}
      >
        {footerNote}
      </Typography>
      <Button
        variant="contained"
        onClick={onNext}
        disabled={nextDisabled}
        sx={
          isLastStep
            ? {
                backgroundImage: gradientBrand,
                "&:hover": {
                  backgroundImage: gradientBrand,
                  filter: "brightness(0.95)",
                },
              }
            : undefined
        }
      >
        {isLastStep ? nextLabel ?? "Crear propiedad" : "Continuar"}
      </Button>
    </Box>
  );
}
